import { jsx as _jsx } from "react/jsx-runtime";
import { getZ3KSensorState } from 'console/shared/hooks/device/z3k/sensors';
import { memo, useMemo } from 'react';
import { SensorContent } from './types';
import { useDeviceConfig } from 'console/shared/contexts/device/config';
import { useZ3KDeviceState } from 'console/shared/hooks/device/z3k';
export const Z3KSensorProvider = memo(function Z3KSensorProvider(props) {
    const { children, sensor_config } = props;
    const { sensor_key } = sensor_config;
    const { z3k_config } = useDeviceConfig();
    const z3k_state = useZ3KDeviceState();
    const sensor_state = getZ3KSensorState(z3k_config, z3k_state, sensor_config, sensor_key);
    const sensor = useMemo(() => ({
        ...sensor_config,
        ...sensor_state,
    }), [sensor_config, sensor_state]);
    return _jsx(SensorContent.Provider, { value: sensor, children: children });
});
